import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import { LoyaltyInPaymentOptionsMode } from "./loyalty_in_payment_options_mode.js";
//#region src/loyalty_in_payment_options_mode_helper.ts
var loyalty_in_payment_options_mode_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(loyaltyInPaymentOptionsMode) {
	switch (loyaltyInPaymentOptionsMode) {
		case LoyaltyInPaymentOptionsMode.Passive: return "Passive (only show button)";
		case LoyaltyInPaymentOptionsMode.PromptIfLoggedIn: return "Prompt if logged in (show button and prompt)";
		case LoyaltyInPaymentOptionsMode.AlwaysPrompt: return "Always prompt (show button and prompt always)";
		case LoyaltyInPaymentOptionsMode.AlwaysPromptWithLoginOptions: return "Always prompt with login options (show button and prompt always, with login options)";
		case LoyaltyInPaymentOptionsMode.PromptInstantEnroll: return "Prompt instant enroll at checkout (show signup form for unauthenticated guests)";
	}
}
//#endregion
export { loyalty_in_payment_options_mode_helper_exports, name };

//# sourceMappingURL=loyalty_in_payment_options_mode_helper.js.map